import Vue from 'vue'
import Vuex from 'vuex'

import userModule from './userModule'
import coursesModule from './coursesModule'
import applicationsModule from './applicationsModule'
import metricsModule from './metricsModule'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user: userModule,
    courses: coursesModule,
    applications: applicationsModule,
    metrics: metricsModule,
  },

  strict: process.env.NODE_ENV !== 'production',
})

export default store



// WEBPACK FOOTER //
// ./client/masteradmin/store/index.js